import type { UserDetails } from '../../API/services/loginService';
const USER_STORAGE_KEY = 'user';

export const setUserToStorage = (user: UserDetails) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

export const getUserFromStorage = (): UserDetails | null => {
  const user = localStorage.getItem(USER_STORAGE_KEY);
  return user ? JSON.parse(user) : null;
};

export const clearUserFromStorage = () => {
  localStorage.removeItem(USER_STORAGE_KEY);
};

export const hasRole = (roles: UserDetails['role'][]) => {
  const user = getUserFromStorage();
  if (!user?.role) return false;
  const userRole = user.role.toLowerCase();
  return roles.map((r) => r.toLowerCase()).includes(userRole);
};
